import { Box } from "@chakra-ui/react";
import { Panel as WPPanel, PanelBody } from "@wordpress/components";
import React from "react";
import { useSharedState } from "../../hooks/useSharedState";
// @ts-ignore
import { useBlockEditContext } from "@wordpress/block-editor";
import { InspectorTabContext } from "./InspectorTabs";

type Props = {
	children: React.ReactNode;
	title: string;
	initialOpen?: boolean;
};

const Panel: React.FC<Props> = (props) => {
	const { children, title, initialOpen } = props;
	const { name } = useBlockEditContext();
	const tab = React.useContext(InspectorTabContext);
	const id = title;
	const key = `inspector-panel-${name}-${tab}-panel`;

	const [panel, setPanel] = useSharedState<string | undefined>(
		key,
		undefined
	);

	React.useEffect(() => {
		if (initialOpen && !panel) {
			setPanel(id);
		}
	}, []); // eslint-disable-line react-hooks/exhaustive-deps

	return (
		<WPPanel>
			<Box
				as={PanelBody}
				title={title}
				opened={id === panel}
				onToggle={() => {
					setPanel(id === panel ? undefined : id);
				}}
				borderBottom="1px solid var(--chakra-colors-gray-200) !important"
				borderTop="none !important"
				mb="1px"
				sx={{
					".components-panel__body-toggle": {
						boxShadow: "none !important",

						"&:hover": {
							color: "#7E36F4",
						},
					},
					"> *:not(:first-child):not(:last-child)": {
						mb: 4,
					},
				}}
			>
				{children}
			</Box>
		</WPPanel>
	);
};

export default Panel;
